// extracted by mini-css-extract-plugin
export var black = "sticky-button-module--black--a2d2a";
export var button = "sticky-button-module--button--c5447";
export var container = "sticky-button-module--container--86909";
export var content = "sticky-button-module--content--c4973";
export var red = "sticky-button-module--red--9e848";
export var white = "sticky-button-module--white--85c98";